// The in-game camera's subjects: each 3D view on the screen (the map, a place you are in, your home) offers a
// photo of itself while it is there; the camera takes the one on top (the last opened). Only the game's own
// pictures: the device's camera is never used.
type Snapshot = () => Promise<Blob | null>;
const views: Snapshot[] = [];

// a view offers its photo; the returned function takes the offer back (when the view closes)
export function offerSnapshot(snapshot: Snapshot) {
  views.push(snapshot);
  return () => {
    const at = views.lastIndexOf(snapshot);
    if (at >= 0) views.splice(at, 1);
  };
}
export const canSnapshot = () => views.length > 0;
export const takeSnapshot = () => views.at(-1)?.() ?? Promise.resolve(null);
